import {$t, $tc} from "@/i18n";
import DialogModule from "../../store/modules/dialog";
import SalesInvoiceModule from "../../store/modules/sales_invoice";
import {isRef} from "@vue/composition-api";
import {Router} from "../../composables/Router";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default function (account_id, selected_invoices, callback) {

    if (!isRef(selected_invoices)) console.error("Invoice delete :: selected invoices must be referenced");
    let invoice_id_list = [];
    const {deleteSalesInvoices, getDeletableInvoices} = SalesInvoiceModule();
    const {setConfirmOptions, openConfirmDialog} = DialogModule();
    const router = Router();

    const onConfirm = async () => {
        deleteSalesInvoices(account_id, invoice_id_list)
            .then(function () {
                if (callback) callback();
                return router.go(-1)
            })
            .catch(ex => errorDialog.showError(ex));
    };

    const onDeleteInvoicesClick = () => {
        account_id = account_id ? account_id : selected_invoices.value[0].account_id;
        invoice_id_list = getDeletableInvoices(selected_invoices.value).map(invoice => invoice.id);

        console.info('onDeleteInvoicesClick account_id', account_id)
        console.info('onDeleteInvoicesClick invoice_id_list', invoice_id_list)

        const title = $tc("Delete invoice | Deleting invoices", invoice_id_list.length) + (invoice_id_list.length >= 2 ? " (" + invoice_id_list.length + ")" : "");
        const text = $t("Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.")
        setConfirmOptions({title, text: text, confirm_text: $t("Continue"), cancel_text: $t("Cancel"), action: onConfirm});
        openConfirmDialog();
    };

    return {onDeleteInvoicesClick};
};
